import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import Form from '@rjsf/core'
import { AnyObject } from '@feedyou/utils'
import { FormValidation, RegistryWidgetsType } from '@rjsf/utils'

import { modalsActions } from '../../../store/modals/modalsSlice'
import { CustomPopup } from '../CustomPopup'
import { GenericFormData } from '../types'
import { ModalFooterButton } from '../styles'
import { ButtonProps } from '../../design-system/Button'
import { FeedbotRjsfForm } from '../../design-system/FeedbotRjsfForm'

type Props<FormData extends GenericFormData> = {
  title: string
  isLoading?: boolean
  closeOnSave?: boolean
  options?: { closeOnSubmit?: boolean }
  onChange: (formData: FormData) => void
  formData: FormData
  validateSchema?: (formData: FormData, errors: FormValidation) => FormValidation
  onSubmit?(formData: FormData): void
  onReject?(formData: FormData): void
  schema: any
  uiSchema: any
  formContext?: AnyObject
  modalStyle?: ReactModal.Styles
  labels?: { buttons?: { submit?: string; cancel?: string } }
  middleControlButtons?: (ButtonProps & { key: string })[]
  widgets?: RegistryWidgetsType
}

export const CustomFormPopup = <FormData extends GenericFormData>({
  title,
  schema,
  labels,
  options,
  widgets,
  formData,
  uiSchema,
  isLoading,
  modalStyle,
  formContext,
  onChange,
  onSubmit,
  onReject,
  validateSchema,
  middleControlButtons = []
}: Props<FormData>) => {
  const dispatch = useDispatch()
  const formComponentRef = useRef<Form<any>>()
  const submitButtonRef = useRef<HTMLButtonElement>()

  const close = () => dispatch(modalsActions.closeModal())
  return (
    <CustomPopup
      title={title}
      modalStyle={modalStyle}
      footer={
        <>
          <ModalFooterButton
            label={labels?.buttons?.cancel || 'Close'}
            onClick={() => (onReject ? onReject(formData) : close())}
          />
          {middleControlButtons.map(props => (
            <ModalFooterButton {...props} />
          ))}
          <ModalFooterButton
            label={labels?.buttons?.submit || 'Ok'}
            emphasis="primary"
            loading={isLoading}
            disabled={isLoading}
            onClick={() => submitButtonRef.current?.click?.()}
          />
        </>
      }
    >
      <FeedbotRjsfForm
        ref={formComponentRef as any}
        liveValidate
        schema={schema}
        widgets={widgets}
        uiSchema={uiSchema}
        formData={formData}
        formContext={formContext}
        customValidate={validateSchema}
        className="no-error-panel-for-custom-modal"
        onChange={({ formData }) => onChange(formData)}
        onSubmit={({ formData }) => {
          onSubmit?.(formData)
          if (options?.closeOnSubmit) {
            close()
          }
        }}
      >
        <button hidden type="submit" ref={submitButtonRef as any} />
      </FeedbotRjsfForm>
    </CustomPopup>
  )
}
